import React, { } from 'react';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function ObjectContextDescription(props) {
    const { object: instance, item, title, extend, render } = props;
    // useEffect(() => {

    // }, [item])
    return (
        <div>
            {instance?.nazvanie &&
                <div style={{ display: "flex", gap: "5px", paddingBottom: "10px" }}>
                    {title && <div>
                        <span style={{ fontWeight: "300" }}>{title}: </span>
                    </div>}
                    <div>
                        {instance?.meropriyatie && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>{instance?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(instance?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(instance?.meropriyatie?.mestoProvedeniya) ? "(" + instance?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}
                        </div>}
                        {instance?.organizatorFederatsiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>Федерация</span>
                        </div>}
                        {instance?.organizatorRegionalnoeOtdelenieID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>{instance?.organizatorRegionalnoeOtdelenie?.nazvanie}</span>
                        </div>}
                        {instance?.organizatorShkolaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>{instance?.organizatorShkola?.nazvanieShkoliTantsev}</span>
                        </div>}
                        {instance?.organizatorMeropriyatiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>{instance?.organizatorMeropriyatiya?.nazvanie}</span>
                        </div>}
                    </div>
                </div>
            }
            {extend && extend()}
        </div>
    )
}
